import { type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'pages',
        component: () => import('pages/PageList/PageList.vue'),
      },
      {
        path: '/folders/:id',
        name: 'folders',
        component: () => import('pages/PageList/PageList.vue'),
      },
      {
        path: '/settings/:tab?',
        name: 'settings',
        component: () => import('pages/Settings/SettingsPage.vue'),
      },
      {
        path: '/letsbookers/:tab?',
        name: 'letsbookers',
        component: () => import('pages/LetsbookerArea/LetsbookerPage.vue'),
      },
      {
        path: '/trash',
        name: 'trash',
        component: () => import('pages/TrashPage.vue'),
      },
      {
        path: '/modals',
        name: 'modals',
        component: () => import('pages/ModalList/ModalList.vue'),
      },
      {
        path: '/metrics',
        name: 'metrics',
        component: () => import('pages/Metrics/MetricsDashboard.vue'),
      },
      {
        path: '/components',
        name: 'components',
        component: () => import('pages/ComponentsPage.vue'),
      },
    ],
  },
  {
    // Ref: https://router.vuejs.org/guide/essentials/route-matching-syntax.html#Custom-regex-in-params
    path: '/editor/:language/:urlPath(.+)',
    name: 'editor',
    component: () => import('pages/Editor/PageEditor.vue'),
    props: true,
  },
  {
    path: '/editor/pop-up/:id',
    name: 'modal-editor',
    component: () => import('pages/Editor/ModalEditor.vue'),
    props: true,
  },
  {
    path: '/preview/:language/:urlPath(.+)',
    name: 'preview',
    component: () => import('pages/PagePreview.vue'),
    props: true,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('pages/Login/LoginPage.vue'),
  },

  {
    path: '/be',
    name: 'be',
    component: () => import('pages/BEPage.vue'),
    beforeEnter: (to, from, next) => {
      if (process.env.ENV_NAME === 'prd') {
        next(false); // cancela a navegação
      } else {
        next();
      }
    },
  },

  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('pages/MaintenancePage.vue'),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    name: 'error',
    component: () => import('pages/ErrorNotFound.vue'),
    props: { message: 'Página não encontrada.' },
  },
];

export default routes;
